import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import iconClean from '../../images/icons/iconClean.svg';
import editIcon from '../../images/icons/editIcon.svg';
import editDetailsIcon from '../../images/icons/edit_icon.svg';
import DataTableComponent from '../common/DatableComponent';
import Header from '../common/Header';
import SubHeader from '../common/SubHeader';
import ButtonComponent from '../common/ButtonComponent';
import plusIcon from '../../images/icons/plus_icon.svg';
import getVendorList from './queries/getVendorList';
import deleteVendor from './queries/deleteVendor';
import showAlert from '../../utils/alert';
import SearchBar from '../common/SearchBar';
import ConfirmClear from '../Modal/ConfirmClear';
import { resetFilter } from '../../features/fliter/filterSlice';
import { resetPage } from '../../features/pagecount/pageSlice';
import { updateVendorFliter, resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import HOCSidePanel from '../expenseItem/HOCPanel';
import AddEditVendorPanel from './AddEditVendorPanel';

const VendorListing = () => {
  const filterData = useSelector((state) => state.filterVendor.filterData);
  const [search, setsearch] = useState(filterData?.search);
  const [tableData, settableData] = useState([]);
  const [activePanel, setActivePanel] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const policies = returnPolicies();
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    mutate: deleteItem,
    isSuccess: isDeleteSuccess,
    isError: isDeleteError,
    reset: resetDelete
  } = deleteVendor();

  const handleOpenCreate = () => {
    setEditData(null);
    setActivePanel(true);
  };

  const handleEditVendor = (data) => {
    setEditData(data);
    setActivePanel(true);
  };

  const handleExpenseMapping = (data) => {
    history.push({
      pathname: `/vendor/${data.id}`,
      state: data
    });
  };

  const handleDelete = () => {
    deleteItem(deleteId);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setdeleteModal(true);
  };

  useEffect(() => {
    dispatch(resetFilter());
    dispatch(resetPage());
  }, []);

  const columnHeaders = [
    {
      Header: 'Vendor Code',
      accessor: 'vendorCode'
    },
    {
      Header: 'vendor',
      accessor: 'vendorName'
    },
    {
      Header: 'SAP Vendor Code',
      accessor: (data) => data?.sapVendorCode || '-'
    },
    {
      Header: 'address',
      accessor: 'address'
    },
    {
      Header: 'company',
      accessor: (data) => data?.company?.map(({ name }) => name),
      disableSortBy: true
    },
    {
      Header: 'vendor email',
      accessor: 'email',
      disableSortBy: true
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      disableSortBy: true,
      Cell: (props) => {
        const { row: { original } } = props;
        return (
          <div className="po-table-action">
            {policies?.vendorPolicies?.canEdit && (
              <>
                <button
                  type="button"
                  onClick={() => handleExpenseMapping(original)}
                  title="Edit Vendor to Expense Mapping"
                >
                  <img src={editIcon} alt="Vendor Expense Mapping" className="action-icon w-6" />
                </button>
                <button
                  type="button"
                  onClick={() => openDeleteModal(original?.id)}
                  title="Clear"
                >
                  <img src={iconClean} alt="ClearIcon" className="action-icon w-6" />
                </button>
                <button
                  type="button"
                  onClick={() => handleEditVendor(original)}
                  title="Edit Vendor Details"
                >
                  <img src={editDetailsIcon} alt="Edit Vendor Details" className="action-icon w-6" />
                </button>
              </>
            )}
          </div>
        );
      }
    }
  ];

  const { isLoading, error, data: vendorData, isError } = getVendorList();

  const handleSearch = (value) => {
    setsearch(value);
    dispatch(updateVendorFliter({ search: value }));
  };

  useEffect(() => {
    if (vendorData?.data) {
      const searchedWord = search?.toLowerCase()?.trim();
      const filteredData = vendorData?.data?.filter(
        (i) => i?.vendorName?.toLowerCase()?.includes(searchedWord)
      );
      if (searchedWord?.length > 3) {
        settableData(filteredData);
      } else {
        settableData(vendorData?.data);
        dispatch(resetVendorFilter());
      }
    }
  }, [search, vendorData?.data]);

  if (isDeleteSuccess) {
    setdeleteModal(false);
    showAlert('Expense items mapped to vendor removed successfully', 'success');
    resetDelete();
  }

  if (isDeleteError) {
    showAlert('Something went wrong', 'error');
    setdeleteModal(false);
    resetDelete();
  }

  useEffect(() => {
    if (policies?.vendorPolicies?.canAccess === false) {
      history.push('/');
    }
  }, [policies]);

  return (
    <>
      {policies?.vendorPolicies.canAccess && (
        <div className="md:w-full">
          <Header parentPageLink="/" currentPage="Vendor List" headerName="Vendor to Expense Mapping" />
          <div className="manning-wrapper">
            <SubHeader
              searchComponent={(
                <SearchBar
                  handleSearch={handleSearch}
                  search={search}
                  placeholder="Search Vendor (Minimum 4 characters)"
                />
              )}
              addButtonComponent={policies?.vendorPolicies?.canEdit && (
                <ButtonComponent
                  handleClick={handleOpenCreate}
                  name="ADD VENDOR"
                  icon={plusIcon}
                />
              )}
            />
            <HOCSidePanel
              openSidePanel={activePanel}
              render={() => (
                <AddEditVendorPanel
                  editData={editData}
                  setEditData={setEditData}
                  setActivePanel={setActivePanel}
                />
              )}
            />
            <DataTableComponent
              {...{ isLoading, columnHeaders, tableData, isError, error, localPagination: true }}
            />
          </div>
        </div>
      )}
      {deleteModal && (
        <ConfirmClear
          modal={deleteModal}
          setModal={setdeleteModal}
          handleDelete={handleDelete}
          isDeleteSuccess={isDeleteSuccess}
          isDeleteError={isDeleteError}
          message="Remove"
        />
      )}
    </>
  );
};

export default VendorListing;
